import { createContext } from "react";

import type { SessionDto } from "Src/api/Dto";
import type { UserType } from "Src/api/Enums";

interface UserContextState extends SessionDto {
  unauthorized: boolean;
  // epiKey: string;
  apiKey: string;
}

const defaultUserContextState: UserContextState = {
  brId: "",
  groupId: "",
  id: 0,
  name: "",
  type: {} as UserType,
  subscriptions: [],
  unauthorized: true,
  organizationName: "",
  // epiKey: "",
  apiKey: ""
};

const UserContext = createContext<UserContextState>(defaultUserContextState);

export type { UserContextState };

export { UserContext, defaultUserContextState };
